import { render } from "./ExternalBackendAi.vue?vue&type=template&id=3e427ba6&scoped=true&lang=pug"
import script from "./ExternalBackendAi.vue?vue&type=script&lang=js"
export * from "./ExternalBackendAi.vue?vue&type=script&lang=js"

import "./ExternalBackendAi.vue?vue&type=style&index=0&id=3e427ba6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e427ba6"]])

export default __exports__